module.exports = __webpack_public_path__ + "static/ti.8ed28001.svg";